// App-specific config

// Using CommonJS instead of ES2015+ export, because we also need to
// provide this object to Webpack in vue.config.js.
const name = 'JPWorld Hold'
const domain = 'jpworldhold.com'
const serviceDomain = 'jpworldhold.com'

const brand = {
  name,
  legalName: name,
  group: 'JPWorld',
  domain,
  supportEmail: `help@${domain}`,
  urls: {
    api: `https://api.${serviceDomain}/api/v1`,
    checkout: `//checkout.${serviceDomain}`,
    spot: `https://spot.${serviceDomain}`,
  },
}

module.exports = {
  title: brand.name,
  description: 'Provides C2C service.',
  brand,
}
